import React, { Component } from 'react';
import PropTypes from 'prop-types';
import defaultPropTypes from './default-prop-types';

export default
class StartListRow extends Component {
    static propTypes = {
        item: PropTypes.shape({
            athlete: PropTypes.shape({
                externalId: PropTypes.string
            }),
            order: PropTypes.any,
            bib: PropTypes.any
        }).isRequired,
        i: PropTypes.number.isRequired,
        t: PropTypes.func.isRequired,
        roundActive: PropTypes.any,
        athleteExternalId: PropTypes.string.isRequired,
        athlete: PropTypes.object.isRequired,
        onRef: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        showExtraForAthleteId: PropTypes.any,
        startListColumns: PropTypes.object.isRequired,
        ...defaultPropTypes
    };

    render() {
        const {
            item,
            i,
            colors,
            t,
            roundActive,
            athleteExternalId,
            athlete,
            onRef,
            onClick,
            showExtraForAthleteId,
            startListColumns
        } = this.props;

        const hasExtra = startListColumns.Bib
            || startListColumns.Age
            || startListColumns.Stance
            || startListColumns.Hometown
            || startListColumns.Sponsor;

        const style = {
            ...(i % 2 === 0
                ? colors.itemOdd
                : colors.itemEven
            ),
            ...(athlete.isLive
                ? colors.itemActive
                : {}
            ),
            ...(athlete.isNext && roundActive
                ? colors.itemNext
                : {}
            ),
            ...(hasExtra
                ? { cursor: 'pointer' }
                : {}
            )
        };

        const extraLabelStyle = athlete.isLive
            ? colors.extraActive.label
            : colors.extra.label;

        const extraValueStyle = athlete.isLive
            ? colors.extraActive.value
            : colors.extra.value;

        const extraItemStyle = athlete.isLive
            ? colors.extraActive.item
            : colors.extra.item;

        return (
            <div>
                <div
                    className="row"
                    ref={onRef}
                    style={style}
                    onClick={onClick}
                >
                    <div className="cell cell-no">
                        {item.order}
                    </div>

                    {startListColumns.Bib &&
                        <div className="cell cell-bib">
                            {item.bib}
                        </div>
                    }

                    <div className="cell cell-name">
                        {athlete.fullName}
                        {startListColumns.Nation &&
                        <div className="cell cell-nation">
                            {athlete.nationality}
                        </div>
                        }
                    </div>
                </div>

                {hasExtra && showExtraForAthleteId === athleteExternalId &&
                    <div
                        className="row extra"
                        style={style}
                    >
                        <div className="cell cell-extra">
                            {startListColumns.Age &&
                                <span
                                    className="item"
                                    style={extraItemStyle}
                                >
                                    <span
                                        className="label"
                                        style={extraLabelStyle}
                                    >
                                        {t('Age')}
                                    </span>

                                    {' '}

                                    <span
                                        className="value"
                                        style={extraValueStyle}
                                    >
                                        {athlete.age}
                                    </span>
                                </span>
                            }

                            {' '}

                            {startListColumns.Stance && athlete.stance &&
                                <span
                                    className="item"
                                    style={extraItemStyle}
                                >
                                    <span
                                        className="label"
                                        style={extraLabelStyle}
                                    >
                                        {t('Stance')}
                                    </span>

                                    {' '}

                                    <span
                                        className="value"
                                        style={extraValueStyle}
                                    >
                                        {athlete.stance}
                                    </span>
                                </span>
                            }

                            {' '}

                            {startListColumns.Hometown && athlete.homeTown &&
                                <span
                                    className="item"
                                    style={extraItemStyle}
                                >
                                    <span
                                        className="label"
                                        style={extraLabelStyle}
                                    >
                                        {t('Hometown')}
                                    </span>

                                    {' '}

                                    <span
                                        className="value"
                                        style={extraValueStyle}
                                    >
                                        {athlete.homeTown}
                                    </span>
                                </span>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableStartList/row.js